(() => {
  const SELECTOR = '[data-cartas-signup]';

  function setStatus(statusEl, message, type = '') {
    if (!statusEl) return;

    statusEl.textContent = message || '';
    statusEl.classList.remove('is-error', 'is-success');

    if (type) {
      statusEl.classList.add(`is-${type}`);
    }
  }

  function getOriginLabel() {
    if (!document.referrer) return window.location.pathname;

    try {
      const ref = new URL(document.referrer);
      return `${ref.hostname}${ref.pathname}`;
    } catch (error) {
      return document.referrer;
    }
  }

  function onlyDigits(value) {
    return String(value || '').replace(/\D+/g, '');
  }

  function maskCep(value) {
    const digits = onlyDigits(value).slice(0, 8);

    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Não foi possível consultar o carrinho.');
    }

    return response.json();
  }

  async function clearCart() {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Não foi possível limpar o carrinho atual.');
    }
  }

  async function addCartasItem(payload) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let message = 'Não foi possível iniciar sua participação.';

      try {
        const data = await response.json();
        if (data?.description) message = data.description;
      } catch (error) {}

      throw new Error(message);
    }

    return response.json();
  }

  function getPropertiesFromForm(formData) {
    const properties = {};

    for (const [key, value] of formData.entries()) {
      if (!key.startsWith('properties[')) continue;

      const propertyName = key.replace(/^properties\[/, '').replace(/\]$/, '');
      const normalizedValue = typeof value === 'string' ? value.trim() : value;

      if (normalizedValue !== '') {
        properties[propertyName] = normalizedValue;
      }
    }

    return properties;
  }

  function syncCheckboxGroupValues(form) {
    const destinoHidden = form.querySelector('[data-destino-hidden]');
    const trocarComHidden = form.querySelector('[data-trocar-com-hidden]');

    const destinoEnabled = Boolean(destinoHidden);
    const trocarComEnabled = Boolean(trocarComHidden);

    const destinoValues = destinoEnabled
      ? [...form.querySelectorAll('[data-destino-option]:checked')]
          .map((input) => input.value)
          .filter(Boolean)
      : [];

    const trocarComValues = trocarComEnabled
      ? [...form.querySelectorAll('[data-trocar-com-option]:checked')]
          .map((input) => input.value)
          .filter(Boolean)
      : [];

    if (destinoHidden) {
      destinoHidden.value = destinoValues.join(',');
    }

    if (trocarComHidden) {
      trocarComHidden.value = trocarComValues.join(',');
    }

    return {
      destinoEnabled,
      trocarComEnabled,
      hasDestinoSelected: !destinoEnabled || destinoValues.length > 0,
      hasTrocarComSelected: !trocarComEnabled || trocarComValues.length > 0
    };
  }

  function initCheckboxGroups(form) {
    const inputs = form.querySelectorAll('[data-destino-option], [data-trocar-com-option]');

    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        syncCheckboxGroupValues(form);
      });
    });

    syncCheckboxGroupValues(form);
  }

  async function lookupCep(cep, form) {
    const digits = onlyDigits(cep);
    if (digits.length !== 8) return;

    const logradouroInput = form.querySelector('[data-endereco-logradouro]');
    const bairroInput = form.querySelector('[data-endereco-bairro]');
    const cidadeInput = form.querySelector('[data-endereco-cidade]');
    const estadoSelect = form.querySelector('[data-endereco-estado]');
    const numeroInput = form.querySelector('[data-endereco-numero]');

    const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!response.ok) return;

    const data = await response.json();
    if (data.erro) return;

    if (logradouroInput) logradouroInput.value = data.logradouro || '';
    if (bairroInput) bairroInput.value = data.bairro || '';
    if (cidadeInput) cidadeInput.value = data.localidade || '';
    if (estadoSelect) estadoSelect.value = data.uf || '';

    if (numeroInput) numeroInput.focus();
  }

  function initCepField(form) {
    const cepInput = form.querySelector('[data-cep]');
    if (!cepInput || cepInput.dataset.ready === 'true') return;

    cepInput.dataset.ready = 'true';

    let lastLookup = '';

    cepInput.addEventListener('input', async () => {
      cepInput.value = maskCep(cepInput.value);

      const digits = onlyDigits(cepInput.value);

      if (digits.length === 8 && digits !== lastLookup) {
        lastLookup = digits;

        try {
          await lookupCep(digits, form);
        } catch (error) {
          console.warn('[Stariná Cartas] Falha ao consultar CEP.', error);
        }
      }
    });
  }

  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (dialog.open) dialog.close();
  }

  function isCartasTrigger(link, sectionEl) {
    const href = link.getAttribute('href') || '';
    const triggerPath = sectionEl.dataset.triggerPath || '/experiencia/cartas/participar';
    const defaultVariantId = sectionEl.dataset.defaultVariantId || '';

    if (link.hasAttribute('data-cartas-open')) return true;
    if (href.includes(triggerPath)) return true;
    if (defaultVariantId && href.includes(`/cart/${defaultVariantId}:1`)) return true;

    return false;
  }

  function initModalTriggers(sectionEl, dialog) {
    const closeButton = dialog.querySelector('[data-cartas-close]');

    if (closeButton) {
      closeButton.addEventListener('click', () => closeDialog(dialog));
    }

    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      const clickedInside =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;

      if (!clickedInside) {
        closeDialog(dialog);
      }
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href], button[data-cartas-open]');
      if (!link) return;
      if (!isCartasTrigger(link, sectionEl)) return;

      event.preventDefault();
      openDialog(dialog);
    });
  }

  async function handleSubmit(sectionEl, dialog, form) {
    const statusEl = form.querySelector('[data-cartas-status]');
    const submitButton = form.querySelector('[data-cartas-submit]');
    const originInput = form.querySelector('[data-cartas-origin]');

    setStatus(statusEl, '');

    if (originInput) {
      originInput.value = getOriginLabel();
    }

    const checkboxState = syncCheckboxGroupValues(form);

    if (!checkboxState.hasDestinoSelected) {
      setStatus(statusEl, 'Selecione pelo menos uma opção em “Onde sua carta pode chegar?”.', 'error');
      return;
    }

    if (!checkboxState.hasTrocarComSelected) {
      setStatus(statusEl, 'Selecione pelo menos uma opção em “Com quem você deseja trocar cartas?”.', 'error');
      return;
    }

    if (!form.reportValidity()) {
      setStatus(statusEl, 'Preencha todos os campos para continuar.', 'error');
      return;
    }

    const originalText = submitButton ? submitButton.textContent : '';
    const loadingText = sectionEl.dataset.submitLabelLoading || 'PROCESSANDO...';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = loadingText;
    }

    try {
      const formData = new FormData(form);
      const variantId = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity') || 1);
      const properties = getPropertiesFromForm(formData);

      if (!variantId) {
        throw new Error('Nenhuma variante válida foi encontrada.');
      }

      const cart = await fetchCart();

      if (cart.item_count > 0) {
        const shouldShowMessage = sectionEl.dataset.showReplaceCartMessage === 'true';

        if (shouldShowMessage) {
          const replaceMessage =
            sectionEl.dataset.replaceCartMessage ||
            'A experiência Cartas é finalizada em um checkout exclusivo. Ao continuar, o carrinho atual será substituído.';

          const confirmed = window.confirm(replaceMessage);

          if (!confirmed) {
            setStatus(statusEl, 'Seu carrinho foi mantido.', 'error');
            return;
          }
        }

        await clearCart();
      }

      await addCartasItem({
        items: [
          {
            id: variantId,
            quantity,
            properties
          }
        ]
      });

      closeDialog(dialog);
      window.location.href = '/checkout';
    } catch (error) {
      setStatus(statusEl, error.message || 'Ocorreu um erro ao iniciar sua participação.', 'error');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText || sectionEl.dataset.submitLabel || 'ENTRAR PARA O RITUAL';
      }
    }
  }

  function initSection(sectionEl) {
    const dialog = sectionEl.querySelector('[data-cartas-dialog]');
    const form = sectionEl.querySelector('[data-cartas-form]');

    if (!dialog || !form || form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';

    initModalTriggers(sectionEl, dialog);
    initCheckboxGroups(form);
    initCepField(form);

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      handleSubmit(sectionEl, dialog, form);
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();